module.exports = __webpack_public_path__ + "static/media/spidermanHomecoming.fa0bd6ae.jpeg";